import { SwitchYourMatesIDs } from './switch-your-mates';

import type { CampaignIDs, ProductIDs, PromoIDValues } from './base';
import type { CanstarIDValues } from './canstar';
import type { OlyIDValues } from './oly';
import type { OneBigSwitchIDValues } from './one-big-switch';
import type { SwitchYourMatesIDValues } from './switch-your-mates';

export * from './base';
export * from './switch-your-mates';
export * from './one-big-switch';
export * from './oly';
export * from './canstar';

export const promoCodesWithReferrals = [
  SwitchYourMatesIDs.PowerHouse,
  SwitchYourMatesIDs.PowerBusiness,
  SwitchYourMatesIDs.PowerOffset,
  SwitchYourMatesIDs.SwitchSaver,
  SwitchYourMatesIDs.EVDay,
  SwitchYourMatesIDs.EVNight,
  SwitchYourMatesIDs.EVDaySaver,
  SwitchYourMatesIDs.EVNightSaver,
];

export type FluxID =
  | OneBigSwitchIDValues
  | SwitchYourMatesIDValues
  | OlyIDValues
  | CanstarIDValues
  | PromoIDValues
  | null;

export type CampaignID = CampaignIDs | string | null;
export type ProductID = ProductIDs | null;
